import { render, staticRenderFns } from "./swiperBanner.vue?vue&type=template&id=e7b2dee4&scoped=true"
import script from "./swiperBanner.vue?vue&type=script&lang=js"
export * from "./swiperBanner.vue?vue&type=script&lang=js"
import style0 from "./swiperBanner.vue?vue&type=style&index=0&id=e7b2dee4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7b2dee4",
  null
  
)

export default component.exports